import { render } from "./ServerUpdatedToast.vue?vue&type=template&id=5bb004d1&scoped=true"
const script = {}

import "./ServerUpdatedToast.vue?vue&type=style&index=0&id=5bb004d1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb004d1"]])

export default __exports__